import React from 'react';
import Header from './Header';
import Body from './Body';

function LiveCasino(props) {
    return (
        <div className="main-container">
            <Header />
            <Body />
        </div>
    );
}

export default LiveCasino;
